export const additionalServicesConstants = {
    //Get product ref
    ADD_ADDITIONAL_SERVICES_REQUEST: "ADD_ADDITIONAL_SERVICES_REQUEST",
    ADD_ADDITIONAL_SERVICES_SUCCESS: "ADD_ADDITIONAL_SERVICES_SUCCESS",
    ADD_ADDITIONAL_SERVICES_FAILURE: "ADD_ADDITIONAL_SERVICES_FAILURE",
}